<template lang="pug">
    el-dialog(
      :title="!ruleForm.id ? '新建比赛' : '修改比赛信息'",
      class="el-dialog-custom",
      top="3vh",
      width="95%",
      :visible.sync="visible",
      @open="openForm()",
      :append-to-body="true",
      :modal-append-to-body="false",
      @close="closeForm()"
    )
      el-form(
        :model="ruleForm",
        :inline="false",
        :rules="rules",
        ref="ruleForm",
        label-width="140px",
        @submit.native.prevent
      )
        el-card(shadow="never")
          div(slot="header")
            font(style="font-weight: bold; font-size: 18px") 比赛设置
          div
          el-form-item(label="比赛名称:", prop="matchName")
            el-input.width_ct(
              v-model="ruleForm.matchName",
              @input="descInput",
              placeholder="请填写比赛名称",
              type="text",
              maxlength="40",
              show-word-limit
            )
            font.font_later 您还可以输入
            font.font_style {{ nameFont }}
            font.font_color 个字!
          el-form-item(label="主办方:", prop="userGroupId")
            el-select.sel_width_ct(
              v-model="ruleForm.userGroupId",
              placeholder="请选择主办方",
              filterable,
              clearable,
              @change="changeCity"
            )
              el-option(
                v-for="(item, index) in sysOrgList",
                :key="index",
                :label="item.name",
                :value="item.orgId"
              )
          el-form-item(label="主办城市:", prop="provinceCode")
            el-col(style="width: 20%")
              el-select(
                v-model="ruleForm.provinceCode",
                placeholder="请选择省",
                style="width: 100%",
                :disabled="cityDisbaled",
                @change="changeProvice"
              )
                el-option(
                  v-for="(item, index) in provinceList",
                  :key="index",
                  :label="item.name",
                  :value="item.code"
                )
            el-col.line(style="width: 2%") &nbsp;&nbsp;省&nbsp;&nbsp;
            el-col(style="width: 20%")
              el-select(
                v-model="ruleForm.cityCode",
                placeholder="请选择市",
                style="width: 100%",
                :disabled="provinceDisabled",
                @change="selectCity"
              )
                el-option(
                  v-for="(item, index) in cityList",
                  :key="index",
                  :label="item.cityname",
                  :value="item.citycode"
                )
            el-col(style="width: 20%") &nbsp;&nbsp;市&nbsp;
          el-form-item(label="比赛场地:", prop="venueId")
            el-select.sel_width_ct(
              v-model="ruleForm.venueId",
              placeholder="请选择比赛场地",
              clearable,
              :disabled="venueIdDisabled",
              @change="venueIdChange"
            )
              el-option(
                v-for="(item, index) in venueList",
                :key="index",
                :label="item.name",
                :value="item.id"
              )
            font.font_later(v-if="ruleForm.venueAddress") 地址: {{ ruleForm.venueAddress }}
          el-form-item(label="比赛类型:", prop="matchType")
            el-select.sel_width_ct(
              v-model="ruleForm.matchType",
              placeholder="请选择比赛类型",
              clearable
            )
              el-option(
                v-for="(item, index) in ctTypeList",
                :label="item.label",
                :value="item.key"
              )
          el-form-item(label="签位:", prop="applySize")
            el-input.sel_width_ct(
              v-model="ruleForm.applySize",
              @change="changeappsize",
              :min="1",
              clearable,
              placeholder="请填写签位数"
            )
              template(slot="suffix") 签位
          el-form-item(label="报名时间:", prop="applyDate")
            el-date-picker(
              v-model="ruleForm.applyDate",
              @blur="applyDateChange",
              range-separator="至",
              type="datetimerange",
              start-placeholder="开始时间",
              end-placeholder="截止时间",
              :picker-options="pickerOptions",
              format="yyyy-MM-dd HH:mm:ss",
              value-format="yyyy-MM-dd HH:mm:ss",
              :clearable="false"
            )
          el-form-item(label="比赛时间:", prop="matchStartTime")
            el-date-picker.sel_width_ct(
              v-model="ruleForm.matchStartTime",
              type="datetime",
              :disabled="ctDisabled",
              :placeholder="matchStartTimePlaceholder",
              format="yyyy-MM-dd HH:mm:ss",
              @change="changeMatchStartTime",
              :picker-options="pickerOptionsCt",
              value-format="yyyy-MM-dd HH:mm:ss",
              :clearable="false"
            )              
          el-form-item(label="比赛项目:", prop="projectType")
            el-select.sel_width_ct(
              v-model="ruleForm.projectType",
              placeholder="请选择比赛项目",
              @change="changeProjectType",
              clearable
            )
              el-option(label="单打", :value="1")
              el-option(label="双打", :value="2")
          el-row(style="padding-bottom: 15px", :span="24")
            el-col(:md="6", :sm="5")    
                el-form-item(label="最大添加场次:", prop="maxVenue")
                    el-input(
                    v-model="ruleForm.maxVenue",
                    :min="1",
                    clearable,
                    placeholder="请填写场次数"
                    )
            el-col(:md="6", :sm="5")  
                el-form-item(label="成赛场次:", prop="establishVenue")
                    el-input(
                    v-model="ruleForm.establishVenue",
                    :min="1",
                    clearable,
                    placeholder="请填写场次数"
                    )
                    template(slot="suffix") 场
          el-form-item(label="联系电话:", prop="contactNumber")
            el-input.sel_width_ct(
              v-model="ruleForm.contactNumber",
              :min="1",
              clearable,
              placeholder="请填写联系电话"
            )
          el-form-item(label="列表页图:", prop="imgList")
            el-input(v-model="ruleForm.imgList", v-show="false")
              //- el-upload(:http-request="uploadFileList",action="useless" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
            img.avatar(
              v-if="listImageUrl",
              :src="listImageUrl",
              style="width: 256px; height: 190px",
              @click="openImgdailog(1)"
            )
            i.el-icon-plus.avatar-uploader-icon(
              v-else,
              style="width: 240px; height: 174px",
              @click="openImgdailog(1)"
            )
            imgupload(
              v-if="openImg",
              ref="upimg",
              :width="256",
              :height="190",
              @uploadSuccess="doneup_img_lb"
            )
            el-alert(
              title="建议最小分辨率256×190,上传图片格式仅支持jpg,jpeg,png,大小不超过10M",
              effect="light",
              :closable="false",
              style="margin-top: 10px"
            )
          el-form-item(label="详情页图:", prop="imgDetailList")
            el-input(v-model="ruleForm.imgDetailList", v-show="false")
              //- el-upload(:http-request="uploadFileDetail",action="useless" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
            img.avatar(
              v-if="detailImageUrl",
              :src="detailImageUrl",
              style="width: 750px; height: 310px",
              @click="openImgdailog(2)"
            )
            i.el-icon-plus.avatar-uploader-icon(
              v-else,
              style="width: 317px; height: 178px",
              @click="openImgdailog(2)"
            )
            imgupload(
              v-if="openImg",
              ref="upimg2",
              :width="750",
              :height="310",
              @uploadSuccess="doneup_xq"
            )
            el-alert(
              title="建议最小分辨率750×310,上传图片格式仅支持jpg,jpeg,png,大小不超过10M",
              effect="light",
              :closable="false",
              style="margin-top: 10px"
            )
          el-form-item(label="比赛简介:", prop="matchDescription")
            el-input(
              v-model="ruleForm.matchDescription",
              type="textarea",
              style="display: none"
            )
            d2-quill(
              v-show="showQuill"
              ref="d2-quill",
              v-model="ruleForm.matchDescription",
              style="min-height: 200px"
            )
          el-form-item(label="报名须知:", prop="gameDescription")
            d2-quill(
              v-show="showQuill"
              ref="gameDescription",
              v-model="ruleForm.gameDescription",
              style="min-height: 200px"
            )
          el-form-item(label="比赛规程:", prop="attachmentsList")
            <div v-for="(item,index) in pdfs" style="display:flex">
              <div style="width:600px"> {{ item.fileName }}</div>
              <div v-if="item.loading" >({{ item.loading }}%)</div>
              <a v-if="item.loading == 100" :href="item.url" target="_blank" style="text-decoration: none;margin-left:50px" >下载</a>
              <div v-if="item.loading == 100" @click="deletePdf(index)" style="margin-left:50px" >删除</div>
            </div>
            el-upload.upload-demo(
              drag,
              action="http://118.195.240.186:8046/admin/upload/uploadFile",
              :on-error="loadingFail",
              :before-upload="handleLoading",
              :on-success="savePdfUrl",
              :show-file-list="false",
              :data="uploadData",
              :headers="uploadHeader",
              style="max-width: 500px"
            )
              i.el-icon-upload
              .el-upload__text 将文件拖到此处，或
                em 点击上传
            el-alert(
              title="上传格式仅支持是.pdf，.doc或.docx,大小不超过10M",
              effect="light",
              :closable="false",
              style="margin-top: 10px"
            )
        br
        el-card(shadow="never")
          div(slot="header")
            font(style="font-weight: bold; font-size: 18px") 报名费用
          div
            el-row(style="padding-bottom: 15px", :span="24")
              el-col(:md="23", :sm="5")  
                el-form-item(label="报名费用:", prop="enrollFee")
                  el-input.width_ct(
                    v-model="ruleForm.enrollFee",
                    placeholder="请填写报名费用",
                    type="text",
                    maxlength="40",
                    show-word-limit
                  )
                font.font_later 以关联子赛事为准！
        br
        el-card(shadow="never")
          div(slot="header")
            font(style="font-weight: bold; font-size: 18px") 自动退款设置
          div
            el-row(style="padding-bottom: 15px", :span="24")
              el-col(:md="23", :sm="5")
                el-form-item(label="设置自动退款:" prop="autoRefund")
                   el-radio(v-model="ruleForm.autoRefund" :label="1") 是
                   el-radio(v-model="ruleForm.autoRefund" :label="0") 否
            el-row
              el-col(:span="16")
                el-form-item(label="距比赛开始小时", label-width="auto")
                  el-input-number(
                    v-model="ruleForm.refundTime",
                    :min="0",
                    :max="100000000",
                    :step="0.5"
                    placeholder="请填写时间"
                  )
                  font &nbsp;&nbsp;&nbsp;未达到已报满状态的比赛，参赛人员全额自动退费！
        br
      span.dialog-footer(slot="footer")
        el-button(type="primary", @click="ruleFormSubmit()", :disabled="clickFlag") 确 定
        el-button(@click="closeForm()") 取 消
    
      //- 选择模板
      addFeeTemplate(
        v-if="addFeeTemplateVisible",
        ref="addFeeTemplate",
        @chooseTemplate="chooseTemplate"
      )
    </template>
    <script>
    import util from "@/libs/util.js";
    import { commomDictData } from "@/util/dictionary"; // 字典项
    import addFeeTemplate from "../../../operation/fee/add-fee-template.vue";
    export default {
      components: {
        addFeeTemplate,
      },
      data() {
        var matchDsc_rule = (rule, value, callback) => {
          if (!value || value === "<p><br></p>") {
            callback(new Error("比赛简介不能为空!"));
          } else {
            callback();
          }
        };
        var bigLevelRule = (rule, value, callback) => {
          if (value !== 0 && !value) {
            return callback(new Error("必须选择级别！"));
          } else {
            setTimeout(() => {
              if (this.ruleForm.smallLevel * 1 > this.ruleForm.bigLevel * 1) {
                callback(new Error("最小级别应小于或等于最大级别，请重新选择！"));
              } else {
    
                callback();
              }
            }, 100);
          }
        };
        return {
          pdfs: [],
          uploadHeader: {
            token: util.cookies.get("token"),
            authorization: "Bearer " + util.cookies.get("authorization"),
            // 'Content-Type': 'application/json; charset=utf-8'
          },
          pdfUrl: "",
          uploadData: {
            type: "ctLevel",
          },
          FirstShow: false,
          SecondShow: false,
          activecolor: -1,
          deletesId: -1,
          ctRefund: {
            index: 0,
            minDuration: 0,
            refundScale: 0,
          },
          addFeeTemplateVisible: false,
          clickFlag: false,
          delTableList: [],
          sysOrgList: [],
          cityList: [],
          provinceList: [],
          delCtRefundDisabled: true,
          cityDisbaled: true,
          provinceDisabled: true,
          nameFont: 40,
          venueIdDisabled: true,
          venueList: [],
          placesInfoList: [],
          ageMaxMenMin: 0,
          ageMaxWomenMin: 0,
          ageMaxMenMax: 100,
          ageMaxWomenMax: 100,
          menDisabled: false,
          womenDisabled: false,
          ruleForm: {
            smallLevel:"",
            bigLevel:"",
            groupRiseNum: "",
            id: null,
            matchType: "1",
            matchId: "",
            matchName: "",
            userGroupId: "",
            userGroupName: "",
            cityCode: "",
            cityName: "",
            provinceCode: "",
            provinceName: "",
            venueId: "",
            ctType: "",
            applySize: "",
            maxVenue: "",
            establishVenue: "",
            contactNumber: "",
            enrollFee: "",
            autoRefund: "",
            minDuration: "",
            projectType: null,
            doubleLevelGap: "", //双打级别差
            level: "",
            bench: 1,
            applyDate: [],
            matchSignStartTime: null,
            matchSignEndTime: null,
            matchStartTime: null,
            imgList: "",
            gameDescription: "",
            matchDescription: "",
            imgDetailList: "",
            CertimgList: "",
            repeatSign: 1,
            genderLimit: 2,
            ageLimit: "",
            ageMinMen: undefined,
            ageMaxMen: undefined,
            ageMinWomen: undefined,
            ageMaxWomen: undefined,
            scoreMin: 0,
            venueAddress: "",
            ctRefundList: [],
            inGameManagementMode: 1,
            // outcomeType: 0,
    
            competitionMatchFormatList: [
              {
                matchFormat: "",
                stage: 1,
                groupNum: "",
              },
              {
                matchFormat: "",
                stage: 2,
                crossNum: "",
              },
            ],
            ctEnrollPriceList: [
              {
                id: null,
                name: "注册会员",
                type: 1,
                price: 0.0,
              },
              {
                id: null,
                name: "初始会员",
                type: 2,
                price: 0.0,
              },
              {
                id: null,
                name: "荣誉会员",
                type: 3,
                price: 0.0,
              },
            ],
            matchFormat: "", // 赛制
            recommend: 0, // 是否首页推荐
            FirstCompetition: "",
            SecondCompetition: "",
            crossNum: "",
            groupNum: "",
            ecertList: [], //电子证书设置
            minLevel: null, //级别限定
            maxLevel: null,
            allowPlayOff: null, //设置附加规则 第一阶段
            allowPlayOff1: null, //设置附加规则 第二阶段
          },
          flagType: "",
          loading: null,
          ctDisabled: true,
          matchStartTimePlaceholder: "必须先选择报名时间",
          // pickerOptions: null,
          pickerOptions: {
            // disabledDate: time => {
            //     return (
            //         time <= new Date()
            //     )
            // }
          },
          pickerOptionsCt: null,
          // restaurants:[],
          levelDisabled: true,
          levelOptions: [],
          ctTypeList: [
            { key: '1', label: "分级公开赛" },
            { key: '2', label: "俱乐部赛" },
            { key: '-1', label: "青少年赛" }
          ],
          placeholderLevel: "必须先选择比赛项目",
          rules: {
            matchName: [
              {
                required: true,
                message: "比赛名称不能为空!",
                trigger: "blur",
              },
              { max: 40, message: "长度不能超过40个字符!" },
            ],
            userGroupId: [
              {
                required: true,
                message: "主办方不能为空!",
                trigger: "change",
              },
            ],
            venueId: [
              {
                required: true,
                message: "主办场地不能为空!",
                trigger: "change",
              },
            ],
            imgList: [
              {
                required: true,
                message: "列表页图不能为空!",
                trigger: "change",
              },
            ],
            imgDetailList: [
              {
                required: true,
                message: "详情页图不能为空!",
                trigger: "change",
              },
            ],
            autoRefund: [
             {
                required: true,
                message: "自动退费不能为空!",
                trigger: "change",
              }
            ],
            provinceCode: [
             {
                required: true,
                message: "省份不能为空!",
                trigger: "change",
              }
            ],
            cityCode: [
             {
                required: true,
                message: "城市不能为空!",
                trigger: "change",
              }
            ],
            ctType: [
              {
                required: true,
                message: "比赛类型不能为空!",
                trigger: "change",
              }
            ],
            applySize: [
              {
                required: true,
                message: "签位不能为空!",
                trigger: "blur",
              },
              {
                max: 64,
                message: "签位不能超过10个字符!",
                trigger: "blur",
              },
              {
                pattern: /^[0-9]*[1-9][0-9]*$/,
                message: "请输入正整数",
                trigger: "blur",
              },
            ],
            maxVenue: [
              {
                required: true,
                message: "最大添加场次不能为空!",
                trigger: "blur",
              },
              {
                pattern: /^[0-9]*[1-9][0-9]*$/,
                message: "请输入正整数",
                trigger: "blur",
              },
            ],
            establishVenue: [
              {
                required: true,
                message: "最大添加场次不能为空!",
                trigger: "blur",
              },
              {
                pattern: /^[0-9]*[1-9][0-9]*$/,
                message: "请输入正整数",
                trigger: "blur",
              },
            ],
            enrollFee: [
              {
                required: true,
                message: "报名费用不能为空!",
                trigger: "blur",
              },
              {
                pattern: /^[0-9]*[1-9][0-9]*$/,
                message: "请输入正整数",
                trigger: "blur",
              }
            ],
            contactNumber: [
            {
                required: true,
                message: "联系电话不能为空!",
                trigger: "blur",
              },
              {
                pattern: /^1[3456789]\d{9}$/,
                message: "请输入正确的手机号码格式",
                trigger: "blur",
              }
            ],
            applyDate: [
              {
                required: true,
                message: "报名时间不能为空!",
                trigger: "change",
              },
            ],
            matchStartTime: [
              {
                required: true,
                message: "比赛时间不能为空!",
                trigger: "change",
              },
            ],
            matchType: [
              {
                required: true,
                message: "比赛类型不能为空!",
                trigger: "change",
              },
            ],
            projectType: [
              {
                required: true,
                message: "比赛项目不能为空!",
                trigger: "change",
              },
            ],
            matchDescription: [
              {
                required: true,
                validator: matchDsc_rule,
                trigger: "change",
              },
              // { max: 1000, message: "长度不能超过1000个字符!" },
            ]
          },
          visible: false,
          listImageUrl: "",
          detailImageUrl: "",
          listImageUrlCert: [],
          openImg: "",
          srcList: [
            "http://192.168.1.111/zentao/file-read-4867.png",
            "http://192.168.1.111/zentao/file-read-4867.png",
          ],
          gameSystems: [], // 赛制
          pxLevel1: [],
          pxLevel2:[],
          pxLevel_single: [
            { value: 0, label: "0.0" },
            { value: 0.5, label: "0.5" },
            { value: 1, label: "1.0" },
            { value: 1.5, label: "1.5" },
            { value: 2, label: "2.0" },
            { value: 2.5, label: "2.5" },
            { value: 3, label: "3.0" },
            { value: 3.5, label: "3.5" },
            { value: 4, label: "4.0" },
            { value: 4.5, label: "4.5" },
            { value: 5, label: "5.0" },
          ],
          allowPlayOffData: [
            { label: "无附加赛", value: 0 },
            { label: "第三四名争夺季军", value: 1 },
          ],
          showQuill: false // 这个字段是用来解决Quill富文本编辑器在初始化后会自动聚焦从而导致页面自动滚动的bug
        };
      },
      // created () {
      //   this.pdfs = []
      //   console.log('created')
      //     // this.$refs['d2-quill'].quill.blur();
      // },
      // destroyed () {
      //   console.log('destoryed')
      // },
      mounted() {
        console.log("mounted");
        //this.restaurants = this.loadAll()
        this.initCity();
        // 获取赛制属性列表(字典项) // E_CERT_ REWARD_LEVEL 电子证书 MATCH_FORMAT 赛制
        commomDictData("MATCH_FORMAT", this).then((res) => {
          this.gameSystems = res.list;
        });
      },
      // updated () {
      //   console.log('updated')
      // },
      methods: {
        openForm() {
          this.pdfs = [];
        },
        handleLoading(file) {
          console.log(file.name);
          for (let i = 0; i < this.pdfs.length; i++) {
            if (this.pdfs[i].fileName == file.name) {
              this.$message.error("文件已存在");
              return false;
            }
          }
          let files = file.name.split(".");
          console.log(files);
          let fileSuffix = files[files.length - 1];
          console.log(fileSuffix);
          if (fileSuffix != "pdf" && fileSuffix != "doc" && fileSuffix != "docx") {
            this.$message.error("只能上传pdf，doc和docx格式的文档");
            return false;
          }
          let pdf = {};
          pdf.fileName = file.name;
          pdf.url = "";
          pdf.loading = 0;
          pdf.loaded = false;
          this.pdfs.push(pdf);
          let timer = setInterval(() => {
            // console.log(pdf.loaded)
            if (pdf.loaded) {
              clearInterval(timer);
              pdf.loading = 100;
            } else {
              if (pdf.loading < 99) {
                pdf.loading++;
              }
            }
          }, 100);
        },
        deletePdf(index) {
          let tips = "确定删除？";
          this.$confirm(tips, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.pdfs.splice(index, 1);
              this.$message.success("已删除");
            })
            .catch(() => {
              this.$message.info("已取消！");
            });
        },
        savePdfUrl(res, file, fileList) {
          console.log(res)
          console.log(this.pdfs)
          this.$message.success("上传成功");
          for (let i = 0; i < this.pdfs.length; i++) {
            if (this.pdfs[i].fileName == res.bean.fileName) {
              this.pdfs[i].url = res.path + res.bean.url;
              this.pdfs[i].loading = 100;
              this.pdfs[i].ossId = res.bean.id;
              this.pdfs[i].loaded = true;
              console.log(this.pdfs[i]);
              return 0;
            }
          }
        },
        loadingFail() {
          this.$message.error("上传失败");
        },
        levelAll() {
          if (this.ruleForm.projectType === 1) {
            this.ruleForm.minLevel = "0.0";
            this.ruleForm.maxLevel = "5.0";
          } else {
            this.ruleForm.minLevel = '5.0';
            this.ruleForm.maxLevel = '10.0';
          }
        },
        // 签位数
        changeappsize() {
          // 签位数应小于64
          if (this.ruleForm.applySize > 64) {
            return this.applytesting();
          }
        },
        // changeGroupNum
        changeGroupNum() {
          this.$forceUpdate();
        },
        changeAllowPlayOff() {
          this.$forceUpdate();
        },
        changeAllowPlayOff1() {
          this.$forceUpdate();
        },
        tiemchecking() {
          this.$alert(
            "因二阶段同名次小组循环赛系统支持2-6签的小组对阵，故一阶段小组循环赛分组数也需满足2-6组。请重新设置组数！",
            "提示",
            {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$message({
                  type: "info",
                  message: `请重新设置`,
                });
              },
            }
          );
          return false;
        },
        groupNumNull() {
          this.$alert("赛制为小组循环赛，组数不能位空！！", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$message({
                type: "info",
                message: `请重新设置`,
              });
            },
          });
          return false;
        },
        applytesting() {
          this.$alert("当前系统支持最大签位数为64签。请重新设置！", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$message({
                type: "info",
                message: `请重新设置`,
              });
            },
          });
          return false;
        },
        applychecking() {
          this.$alert(
            "当前系统支持单组（即总签位数/组数）签位数为2/3/4/5/6签。请重新设置！",
            "提示",
            {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$message({
                  type: "info",
                  message: `请重新设置`,
                });
              },
            }
          );
          return false;
        },
        applychecking1() {
          this.$alert(
            "当前系统支持单组（即总签位数/组数）签位数为2/4/6签。请重新设置！",
            "提示",
            {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$message({
                  type: "info",
                  message: `请重新设置`,
                });
              },
            }
          );
        },
        // 删除电子证书
        deletecertImg(item, index) {
          this.listImageUrlCert.splice(index, 1);
        },
        // 鼠标移入
        hoverover(item) {
          // console.log(item)
          this.deletesId = item.imgUrl;
        },
        hoverover1(item) {
          // console.log(item)
          this.activecolor = item.imgUrl;
          console.log(this.activecolor);
          // this.$nextTick(() => {
          //   this.activecolor = item.id
          // })
          // this.$set(this.activecolor, item.id)
        },
        // 鼠标移出
        hoverout(item) {
          console.log(item);
          this.deletesId = -1;
        },
        hoverout2(item) {
          console.log(item);
          this.activecolor = -1;
        },
        init(id, flagType) {
          this.clickFlag = false;
          this.flagType = flagType;
          this.ruleForm.id = id || null;
          this.visible = true;
          this.$nextTick(() => {
            this.$refs["ruleForm"].resetFields();
            this.$refs["d2-quill"].Quill.pasteHTML("");
            this.$refs.gameDescription.Quill.pasteHTML("");
          });
          //数据初始化
          this.ruleForm.level = "";
          this.levelDisabled = true;
          this.placeholderLevel = "必须先选择比赛项目";
          this.ctDisabled = true;
          this.matchStartTimePlaceholder = "必须先选择报名时间";
          this.listImageUrl = "";
          this.detailImageUrl = "";
          this.ctRefund.refundScale = 0;
          this.ctRefund.index = 0;
          this.delTableList = [];
          this.ruleForm.matchSignStartTime = "";
          this.ruleForm.matchSignEndTime = "";
          this.ruleForm.recommend = 0;
          this.ruleForm.applySize = "";
          this.ruleForm.FirstCompetition = "";
          this.ruleForm.groupNum = "";
          this.ruleForm.SecondCompetition = "";
          this.ruleForm.CrossingNum = "";
          this.selClear();
          this.cityDisbaled = true;
          this.provinceDisabled = true;
          this.venueIdDisabled = true;
          this.womenDisabled = false;
          this.menDisabled = false;
          this.nameFont = 40;
    
          // this.dataInit();
          this.listImageUrlCert = [];
          setTimeout(() => {
            this.showQuill = true
          }, 1000)
          //修改回选
          if (this.ruleForm.id) {
            console.log(this.ruleForm.id);
            this.$http({
              url: this.$http.adornUrl(`/ctCompetition/selfSelection/getById/` + this.ruleForm.id),
              method: "get",
            }).then((data) => {
              if (data && data.code === 0) {
                console.log("data:", data);
                this.changeCity(data.data.userGroupId);
                // this.changeProjectType(data.data.projectType);
                this.genderLimitChange(data.data.genderLimit);
                this.ruleForm = data.data;
                this.ruleForm.applySize = data.data.applySize + "";
                this.listImageUrl = data.data.imgListUrl;
                this.detailImageUrl = data.data.imgDetailListUrl;
                this.changeProvice(0);
                this.selectCity(0);
                // this.dataInit();
                this.nameFont = 40 - data.data.matchName.length;
                this.ruleForm.applyDate = [];
                this.ruleForm.applyDate.push(data.data.matchSignStartTime + "");
                this.ruleForm.applyDate.push(data.data.matchSignEndTime + "");
                this.pdfs = data.data.attachmentsList
                  ? data.data.attachmentsList
                  : [];
                console.log(this.pdfs)
                if (this.pdfs.length > 0) {
                  for (let i = 0; i < this.pdfs.length; i++) {
                    this.pdfs[i].loading = 100;
                  }
                }
    
                this.ruleForm.recommend = data.data.recommend;
                this.ruleForm.ctRefundList = [];
                this.levelDisabled = false;
                this.ctDisabled = false;
                this.$nextTick(() => {
                  this.$refs["d2-quill"].Quill.pasteHTML(
                    data.data.matchDescription
                  );
                  this.$refs.gameDescription.Quill.pasteHTML(
                    data.data.gameDescription
                  );
                });
              }
            });
          }
        },
        selectCity(flag) {
          if (flag !== 0) {
            this.venueList = [];
            this.ruleForm.venueId = "";
          }
          this.$http({
            url: this.$http.adornUrl("/pbPlaces/getPlaceById"),
            method: "get",
            params: this.$http.adornParams({
              orgId: this.ruleForm.userGroupId,
              proviceId: this.ruleForm.provinceCode,
              cityId: this.ruleForm.cityCode,
            }),
          }).then((data) => {
            let obj = {};
            let val = this.ruleForm.cityCode;
            if (val) {
              obj = this.cityList.find((item) => {
                return item.citycode === val;
              });
              if (obj) {
                this.ruleForm.cityName = obj.cityname;
              }
            }
            this.venueList = data && data.code === 0 ? data.list : [];
          });
        },
        changeProvice(flag) {
          if (flag !== 0) {
            this.cityList = [];
            this.ruleForm.cityCode = "";
            this.venueList = [];
            this.ruleForm.venueId = "";
          }
          this.$http({
            url: this.$http.adornUrl("/dicProvinceCity/queryByOrgId"),
            method: "get",
            params: this.$http.adornParams({
              orgId: this.ruleForm.userGroupId,
              provinceCode: this.ruleForm.provinceCode,
            }),
          }).then((data) => {
            let obj = {};
            let val = this.ruleForm.provinceCode;
            if (val) {
              obj = this.provinceList.find((item) => {
                return item.code === val;
              });
              if (obj) {
                this.ruleForm.provinceName = obj.name;
              }
            }
            this.cityList = data.list;
          });
        },
        dataInit() {
          //初始化可报名的赛事类型
          this.$http({
            url: this.$http.adornUrl("/sysOrg/getSysOrgByUserId"),
            method: "get",
          }).then((data) => {
            if (data.bean) {
              let arr = [];
              let typeList = data.bean.byx1.split(",");
              this.ctTypeList.forEach((c) => {
                typeList.forEach((t) => {
                  if (t == c.key) {
                    arr.push(c);
                  }
                });
              });
              this.ctTypeList = arr;
            }
          });
        },
        // 比赛名称
        descInput() {
          let len = 40 - this.ruleForm.matchName.length;
          this.nameFont = len;
        },
        // loading
        openFullScreen() {
          this.loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
        },
        //新增方法
        ruleFormSubmit() {
          this.ruleForm.ecertList = this.listImageUrlCert;
          this.$refs["ruleForm"].validate((valid) => {
            if (
              !this.ruleForm.matchDescription ||
              this.ruleForm.matchDescription === "<p><br></p>"
            ) {
              return this.$message.error("比赛简介不能为空！");
            }
    
            this.ruleForm.attachmentsList = this.pdfs;
            this.ruleForm.level=this.ruleForm.smallLevel+'~'+this.ruleForm.bigLevel
            if (valid) {
              this.$showLoading();
              this.ruleForm.matchSignStartTime = this.ruleForm.applyDate[0];
              this.ruleForm.matchSignEndTime = this.ruleForm.applyDate[1];
    
              this.$http({
                url: this.$http.adornUrl(
                  `/ctCompetition/selfSelection/saveOrUpdateBean`
                ),
                method: "post",
                data: this.ruleForm,
              }).then((data) => {
                if (data && data.code === 0) {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                    onClose: () => {
                      this.flagType = 1;
                      this.visible = false;
                      this.$emit("refreshDataList");
                      this.$showLoading("close");
                    },
                  });
                } else {
                  this.$message.error(data.msg);
                  this.$showLoading("close");
                }
              });
            }
          });
        },
        // 关闭
        closeForm() {
          this.showQuill = false
          if (this.flagType === 2) {
            this.$http({
              url: this.$http.adornUrl(`/ctCompetition/delete/` + this.ruleForm.id),
              method: "get",
            }).then((data) => {
              this.visible = false;
            });
          } else {
            this.visible = false;
          }
        },
    
        //报名时间改变事件
        applyDateChange() {
          console.log(this.ruleForm.applyDate);
          if (this.ruleForm.applyDate == null) {
            this.ctDisabled = true;
            this.ruleForm.matchStartTime = null;
            this.matchStartTimePlaceholder = "必须先选择报名时间";
          } else {
            this.ctDisabled = false;
            this.ruleForm.matchStartTime = null;
            this.matchStartTimePlaceholder = "请选择比赛时间";
            this.pickerOptionsCt = {
              disabledDate: (time) => {
                return (
                  time < new Date(this.ruleForm.applyDate[1]) - 1000 * 60 * 59 * 24
                );
              },
            };
          }
        },
        // 比赛时间
        changeMatchStartTime(val) {
          if (this.ruleForm.matchStartTime) {
            let date1 = new Date(this.ruleForm.applyDate[1]).getTime();
            let date2 =
              new Date(this.ruleForm.matchStartTime).getTime() - 1000 * 60;
            if (date1 > date2) {
              this.ruleForm.matchStartTime = null;
              this.matchStartTimePlaceholder =
                "比赛时间必须晚于报名截止时间，请重新选择";
            }
          }
        },
        //打开图片剪裁框
        openImgdailog(type) {
          this.openImg = true;
          this.$nextTick(() => {
            if (type === 1) {
              this.$refs.upimg.init("ctLevel"); //传入图片类型参数
            }
            if (type === 2) {
              this.$refs.upimg2.init("ctLevel"); //传入图片类型参数
            }
            if (type === 3) {
              if (this.ruleForm.prizeList) {
                this.$refs.upimg3.init("ctLevel"); //传入图片类型参数
              } else {
                this.$message.error("请选择奖项等级");
              }
            }
          });
        },
        //剪裁完成的回显 列表页
        doneup_lb(val, url) {
          this.ruleForm.imgList = val;
          this.listImageUrl = url;
          this.openImg = false;
        },
        //电子整数 列表页
        doneup_Cert(val, url, path) {
          this.ruleForm.CertimgList = val;
          let arr = {
            imgUrl: path,
            rewardLevel: this.ruleForm.prizeList,
          };
          console.log(this.verificationBook(path));
          if (this.verificationBook(path)) {
            this.listImageUrlCert.push(arr);
          }
          console.log(val, url, path);
          this.openImg = false;
        },
        // 验证证书是否已经上传
        verificationBook(path) {
          let arr = 1;
    
          this.listImageUrlCert.forEach((item, index) => {
            console.log(item.rewardLevel);
            console.log(this.ruleForm.prizeList);
            if (item.rewardLevel == this.ruleForm.prizeList) {
              this.listImageUrlCert[index].imgUrl = path;
              arr = 0;
              throw Error();
            }
            arr = 1;
          });
          if (arr === 0) {
            return false;
          } else {
            return true;
          }
        },
        //剪裁完成的回显 详情页
        doneup_xq(val, url) {
          this.ruleForm.imgDetailList = val;
          this.detailImageUrl = url;
          this.openImg = false;
        },
        doneup_img_lb(val, url) {
          this.ruleForm.imgList = val;
          this.listImageUrl = url;
          this.openImg = false;
        },
        //自定义上传方法
        //没有用el-upload的action方法，如果使用要传递headers属性参数授权
        /*  uploadFileList (param) {
                    console.log('调用上传方法1：', param)
                    //列表页图
                    this.uploadFile('1', param.file)
                },
                uploadFileDetail (param) {
                    console.log('调用上传方法2：', param)
                    //列表页图
                    this.uploadFile('2', param.file)
                },
                uploadFile (type, file) {
                    console.log('调用上传方法：', file)
                    let fd = new FormData()
                    fd.append('type', 'ctLevel')
                    fd.append('file', file)
                    console.log('调用上传方法3：', fd)
    
                    this.$http({
                        url: this.$http.adornUrl(`/upload/uploadFile`),
                        method: 'post',
                        data: fd
                    }).then((data) => {
                        console.log('调用方法完成', data)
                        if (data && data.code === 0) {
                            //列表页图
                            if (type === '1') {
                                this.ruleForm.imgList = data.bean.id
                                this.listImageUrl = URL.createObjectURL(file)
                            }
                            //详情页图
                            if (type === '2') {
                                this.ruleForm.imgDetailList = data.bean.id
                                this.detailImageUrl = URL.createObjectURL(file)
                            }
                            this.$message.success('上传成功!')
                        } else {
                            this.$message.error('上传失败!')
                        }
                    })
                }, */
        // querySearchApplySize(queryString, cb){
        //     let restaurants = this.restaurants;
        //     let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        //     // 调用 callback 返回建议列表的数据
        //     cb(results);
        // },
        // createFilter(queryString) {
        //     return (restaurant) => {
        //         return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        //     };
        // },
        // loadAll(){
        //     return [
        //         {"value":"2签位"},
        //         {"value":"4签位"},
        //         {"value":"8签位"},
        //         {"value":"16签位"},
        //         {"value":"64签位"},
        //         {"value":"128签位"}
        //     ]
        // },
        //比赛项目改变事件
        changeProjectType(value) {
          if (value) {
            this.levelDisabled = false;
            this.placeholderLevel = "请选择级别";
            if (value === 1) {
              this.levelOptions = this.levelOptionsOne;
              this.pxLevel1 =JSON.parse(JSON.stringify(this.pxLevel_single));
              this.pxLevel2=JSON.parse(JSON.stringify(this.pxLevel_single));
            } else {
              this.levelOptions = this.levelOptionsTwo;
              this.pxLevel1 =JSON.parse(JSON.stringify(this.pxLevel_double));
              this.pxLevel2=JSON.parse(JSON.stringify(this.pxLevel_double));
            }
          } else {
            this.levelDisabled = true;
            this.levelOptions = [];
            this.pxLevel1 = [];
            this.pxLevel2 = [];
            this.placeholderLevel = "必须先选择比赛项目";
          }
          this.ruleForm.level = "";
          this.ruleForm.minLevel = "";
          this.ruleForm.maxLevel = "";
          this.ruleForm.smallLevel = "";
          this.ruleForm.bigLevel = "";
        },
        // 初始设置级别与级别限定联动
        // changeLevel(value) {
        //   this.ruleForm.minLevel = value;
        //   this.ruleForm.maxLevel = value;
        // },
        changeSmallLevel(value){
           this.ruleForm.minLevel = value;
           this.pxLevel1.map(item=>{
            if(item.value<Number(value)){
              item.disabled=true
            }else{
              item.disabled=false
            }
            })
        },
        changeBigLevel(value){
           this.ruleForm.maxLevel =value;
           this.pxLevel2.map(item=>{
             if(item.value>Number(value)){
                item.disabled=true
              }else{
                item.disabled=false
              }
           })
        },
        
        startAgeMenChange(value) {
          this.ageMaxMenMin = value;
        },
        endAgeMenChange(value) {
          this.ageMaxMenMax = value;
        },
        startAgeWomenChange(value) {
          this.ageMaxWomenMin = value;
        },
        endAgeWomenChange(value) {
          this.ageMaxWomenMax = value;
        },
        genderLimitChange(label) {
          //男
          if (label === 0) {
            this.womenDisabled = true;
            this.menDisabled = false;
            this.ruleForm.ageMinWomen = undefined;
            this.ruleForm.ageMaxWomen = undefined;
          }
          //女
          if (label === 1) {
            this.menDisabled = true;
            this.womenDisabled = false;
            this.ruleForm.ageMinMen = undefined;
            this.ruleForm.ageMaxMen = undefined;
          }
          //全部
          if (label === 2) {
            this.menDisabled = false;
            this.womenDisabled = false;
          }
        },
        // table多选事件
        selectionChangeHandle(val) {
          this.delTableList = val;
          if (this.delTableList.length === 0) {
            this.delCtRefundDisabled = true;
          } else {
            this.delCtRefundDisabled = false;
          }
        },
        //退款设置添加事件
        addCtRefund() {
          if (this.minDuration === undefined) {
            this.$message.error("距比赛开始时间不能为空!");
            return;
          }
        },
        //退款设置删除事件
        delCtRefund() {
          for (let i of this.delTableList) {
            this.ruleForm.ctRefundList.splice(i.index - 1, 1);
            for (let j = 0; j < this.ruleForm.ctRefundList.length; j++) {
              this.ruleForm.ctRefundList[j].index = j + 1;
            }
          }
        },
        initCity() {
          this.$http({
            url: this.$http.adornUrl("/sysOrg/list"),
            method: "get",
          }).then((data) => {
            this.sysOrgList = data && data.code === 0 ? data.list : [];
          });
        },
        selClear() {
          this.placesInfoList = [];
          this.ruleForm.venueAddress = "";
          this.ruleForm.venueId = "";
          this.venueList = [];
          this.ruleForm.cityCode = "";
          this.ruleForm.cityName = "";
          this.cityList = [];
          this.ruleForm.provinceCode = "";
          this.ruleForm.provinceName = "";
          this.provinceList = [];
        },
        changeCity(val) {
          this.selClear();
          if (val === "" || val === null) {
            this.cityDisbaled = true;
            this.provinceDisabled = true;
            this.venueIdDisabled = true;
            return;
          } else {
            this.cityDisbaled = false;
            this.provinceDisabled = false;
            this.venueIdDisabled = false;
          }
          this.ruleForm.userGroupName = this.sysOrgList.filter(sol => sol.orgId === val)[0].name
          this.getById(val);
          
        },
        //获取省和市
        getById(val) {
          this.$http({
            url: this.$http.adornUrl(`/dicProvince/queryByOrgId/` + val),
            params: this.$http.adornParams({
              orgId: val,
            }),
            method: "get",
          }).then((data) => {
            if (data && data.code === 0) {
              this.provinceList = data.list;
            }
          });
        },
        //获取主办方
        getByOrgId(val) {
          this.$http({
            url: this.$http.adornUrl(`/pbPlaces/getByOrgId/` + val),
            method: "get",
          }).then((data) => {
            if (data && data.code === 0) {
              this.placesInfoList = data.pbPlacesList;
              for (let i of data.pbPlacesList) {
                this.venueList.push({
                  label: i.name,
                  value: i.id,
                });
              }
            }
          });
        },
        venueIdChange(val) {
          let obj = {};
          if (val) {
            obj = this.venueList.find((item) => {
              return item.id === val;
            });
            if (obj) {
              this.ruleForm.venueAddress = obj.address;
            }
          }
    
          // console.log(this.venueList)
          // if(val == '' || val === null){
          //     this.ruleForm.venueAddress = ''
          // }else{
          //     this.placesInfoList.forEach(data =>{
          //         if(data.id == val){
          //             this.ruleForm.venueAddress = data.address
          //         }
          //     })
          // }
        },
        addFeeTemplate(type) {
          console.log("type:", type);
          this.addFeeTemplateVisible = true;
          this.$nextTick(() => {
            this.$refs.addFeeTemplate.init(type);
          });
        },
        chooseTemplate(list, type) {
          console.log("选择模板：", type, list);
          this.addFeeTemplateVisible = false;
          if (type === 1) {
            this.ruleForm.ctEnrollPriceList = [];
            list.forEach((e) => {
              if (e.typeRole === 1 && e.typeVal === 1) {
                let da = {
                  id: null,
                  name: "注册会员",
                  type: 1,
                  price: e.value,
                };
                this.ruleForm.ctEnrollPriceList.push(da);
              } else if (e.typeRole === 1 && e.typeVal === 2) {
                let da = {
                  id: null,
                  name: "初始会员",
                  type: 2,
                  price: e.value,
                };
                this.ruleForm.ctEnrollPriceList.push(da);
              } else if (e.typeRole === 1 && e.typeVal === 3) {
                let da = {
                  id: null,
                  name: "荣誉会员",
                  type: 3,
                  price: e.value,
                };
                this.ruleForm.ctEnrollPriceList.push(da);
              }
            });
          } else if (type === 2) {
            this.ruleForm.ctRefundList = [];
            let index = 1;
            for (let i of list) {
              this.ruleForm.ctRefundList.push({
                index: index++,
                minDuration: i.typeVal,
                refundScale: i.value,
              });
            }
          }
        },
      },
    };
    </script>

    <style scoped>
    .el-dialog-custom {
      overflow: hidden !important;
    }
    .el-dialog-custom /deep/ .el-dialog__body {
      height: 73vh;
      overflow: auto;
    }
    .el-dialog-custom /deep/ .el-dialog__footer {
      border-top: 1px solid #E9E9E9;
    }
    </style>

    <style>
    .imagemore {
      /* display: inline-block; */
      margin-top: 20px;
    }
    .imagelist {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
    
      align-items: center;
    }
    .infocont {
      display: inline-block;
      margin-right: 30px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 5px;
      overflow: hidden;
    }
    .deletes .el-icon-delete {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 100;
      color: white;
      font-size: 20px;
    }
    .chosecolor {
      color: #02b90d !important;
    }
    .deletes {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
    }
    .deletes .Mask {
      width: 100%;
      height: 100%;
      background: black;
      opacity: 0.8;
      position: absolute;
      left: 0;
      top: 0;
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
      border: 1px dashed #ccc;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    .width_ct {
      width: 50%;
    }
    .sel_width_ct,
    .input_width_ct {
      width: 20% !important;
    }
    .font_later {
      padding-left: 20px;
      font-weight: bold;
      color: #909399;
    }
    .font_color {
      font-weight: bold;
      color: #909399;
    }
    .font_style {
      font-weight: bold;
      color: red;
    }
    .dialog-footer {
      padding-bottom: 150px;
    }
    .dialog-right {
      float: right;
    }    
    
    /* 提示框 */
    .el-tooltip__popper.is-light {
      border: 1px solid #c0c4cc;
    }
    
    .el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
      border-bottom-color: grey !important ;
    }
    
    .toolTip > p {
      margin: 0;
      padding-top: 10px;
      height: 14px;
      line-height: 14px;
      font-size: 14px;
      color: #606266;
    }
    
    /* 文本框剩余数字提示兼容ie */
    .el-input .el-input__count .el-input__count-inner {
      background: none;
      line-height: initial;
      display: inline-block;
      padding: 0 5px;
    }
    /* 弹出遮罩层 兼容ie*/
    .el-dialog__wrapper {
      width: 100% !important;
      height: 100% !important;
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      overflow: auto;
      margin: 0;
    }
    </style>
    <style lang="scss" scoped>
    .rankLimit {
      display: flex;
      align-items: center;
      .select_width {
        width: 180px;
      }
      .btn {
        margin: 0 0 22px 15px;
      }
      .empty {
        margin: 0 0 22px 10px;
      }
      .ageStyle {
        margin-left: -130px;
        .el-form-item__error {
          width: 500px;
        }
      }
    }
    </style>
    